module.exports = __webpack_public_path__ + "static/img/t5_3.f107a18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/technology/t5_3.jpg
// module id = pzTj
// module chunks = 0